import React from "react";
import { TileLayer } from "react-leaflet";
import { getTileLayers } from "./tileLayers";

/**
 * Thin wrapper around react-leaflet's `<TileLayer />` that selects the
 * appropriate provider(s) based on a single `view` prop.
 *
 * Fase 2B (b99.10.10) — extracted so the public TripOverviewMap and the
 * editor RouteMapViewer share the same tile-rendering primitive.
 *
 * b99.10.11 — agora consome `getTileLayers()` (sempre array) e renderiza
 * múltiplas `<TileLayer />` empilhadas. Necessário para a vista Híbrida
 * (satélite + Transportation + Boundaries_and_Places).
 *
 * Cada layer leva uma `key` derivada do `view` + index para forçar Leaflet
 * a remontar quando a view muda (Leaflet não observa `url` changes).
 */
export default function MapTileLayer({ view = "2d" }) {
  const layers = getTileLayers(view);
  return (
    <>
      {layers.map((layer, i) => (
        <TileLayer
          key={`${view}-${i}`}
          url={layer.url}
          attribution={layer.attribution || ""}
          opacity={layer.opacity ?? 1}
          // Apenas a base (i=0) declara o atributo de teste para evitar
          // múltiplos elementos com o mesmo data-testid na vista híbrida.
          {...(i === 0 ? { "data-testid": `map-tile-layer-${view}` } : {})}
        />
      ))}
    </>
  );
}
